/* Preserve Cliff assistance separately from acquisition UTMs. No email/chat data. */
(() => {
  'use strict';
  const KEY = 'basin_cliff_assist_v1';
  const ATTRIBUTE = '__cliff_click_id';
  // A nonempty tombstone overrides stale private line properties after withdrawal.
  const REVOKED = 'revoked';
  const TTL = 30 * 86400 * 1000;
  const valid = (value) => typeof value === 'string' && /^[a-f0-9]{32}$/.test(value);
  const incoming = new URL(window.location.href).searchParams.get('cliff_click');
  let current = null;
  let written;
  let writing = Promise.resolve();

  function permitted() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && privacy.analyticsProcessingAllowed() && privacy.marketingAllowed());
  }

  function read() {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY));
      if (saved && valid(saved.id) && Number.isFinite(saved.at) && Date.now() >= saved.at && Date.now() - saved.at < TTL) return saved;
    } catch (_) { /* Restricted storage must not break shopping. */ }
    return null;
  }

  function persistCart(id) {
    // Serialize updates so a delayed grant cannot overwrite a later revocation.
    writing = writing.then(async () => {
      const next = permitted() && id ? id : REVOKED;
      if (written === next) return;
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [ATTRIBUTE]: next } }),
          signal: AbortSignal.timeout(2000)
        });
        if (response.ok) written = next;
      } catch (_) { /* A tracking outage never prevents a purchase. */ }
    });
    return writing;
  }

  function updateBookingProperty() {
    // Servicify reads document-wide properties for both cart and draft-order checkout.
    const elementId = 'basin-cliff-booking-property';
    let input = document.getElementById(elementId);
    if (!permitted() || !current || Date.now() - current.at >= TTL) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.id = elementId;
      input.type = 'hidden';
      input.name = 'properties[_cliff_click_id]';
      document.body.appendChild(input);
    }
    input.value = current.id;
  }

  function sync() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;
    let savedExists = false;
    try { savedExists = localStorage.getItem(KEY) !== null; } catch (_) {}
    const hadAssist = !!current || savedExists || !!written;
    if (!permitted()) {
      current = null;
      try { localStorage.removeItem(KEY); } catch (_) {}
      updateBookingProperty();
      if (hadAssist) persistCart('');
      return;
    }
    current = current || (valid(incoming) ? { id: incoming, at: Date.now() } : read());
    if (current && Date.now() - current.at >= TTL) current = null;
    try {
      if (current) localStorage.setItem(KEY, JSON.stringify(current));
      else localStorage.removeItem(KEY);
    } catch (_) {}
    updateBookingProperty();
    if (current || hadAssist) persistCart(current ? current.id : '');
  }

  // Permalinks create a new cart and can go straight to checkout. Carry the
  // attribute on that new cart, preserving quantity, discounts, and campaigns.
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin === window.location.origin && /^\/cart\/\d/.test(destination.pathname)) {
      destination.searchParams.delete('attributes[' + ATTRIBUTE + ']');
      if (permitted() && current && Date.now() - current.at < TTL) {
        destination.searchParams.set('attributes[' + ATTRIBUTE + ']', current.id);
      } else {
        destination.searchParams.set('attributes[' + ATTRIBUTE + ']', REVOKED);
      }
      link.href = destination.href;
    }
  }, true);
  document.addEventListener('submit', () => { updateBookingProperty(); if (current) persistCart(current.id); }, true);
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', sync);
  if (window.Shopify && window.Shopify.customerPrivacy) sync();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) sync(); });
  }
})();
